"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.FacultySchema = exports.FacultyIMSchema = exports.BaseFacultySchema = exports.FACULTY_CODE_ENUM = exports.FacultyCodes = void 0;
const z = __importStar(require("zod"));
const contact_schema_1 = require("./contact-schema");
var FacultyCodes;
(function (FacultyCodes) {
    FacultyCodes["AgriSciences"] = "AGRISCIENCES";
    FacultyCodes["Arts and Social Sciences"] = "ARTS_SOCIAL";
    FacultyCodes["Economic and Management Sciences"] = "ECONOMIC_MGMT";
    FacultyCodes["Education"] = "EDUCATION";
    FacultyCodes["Engineering"] = "ENGINEERING";
    FacultyCodes["Law"] = "LAW";
    FacultyCodes["Medicine and Health Sciences"] = "MEDICINE_HEALTH";
    FacultyCodes["Military Science"] = "MILITARY";
    FacultyCodes["Science"] = "SCIENCE";
    FacultyCodes["Theology"] = "THEOLOGY";
    FacultyCodes["School for Data Science and Computational Thinking"] = "DATA";
    FacultyCodes["School for Climate Studies"] = "CLIMATE";
    FacultyCodes["Division of Research Development Approval"] = "DRD_APPROVAL";
    FacultyCodes["TTO Director Approval"] = "DIRECTOR_APPROVAL";
})(FacultyCodes || (exports.FacultyCodes = FacultyCodes = {}));
exports.FACULTY_CODE_ENUM = z.nativeEnum(FacultyCodes);
exports.BaseFacultySchema = z.object({
    id: z.string().min(3, 'Required'),
    name: z.string().min(3, 'Required'),
    contactId: z.string().min(3),
});
// Note: "id" is not a default generated uuid but rather provided by user input.
// A typical rule is the name of the faculty in all caps for the id (example: AGRISCIENCE)
exports.FacultyIMSchema = exports.BaseFacultySchema;
exports.FacultySchema = z.lazy(() => {
    return exports.BaseFacultySchema.extend({
        contact: contact_schema_1.BaseContactSchema,
    });
});
